import { createStore } from 'vuex';

export default createStore({
  state: {
    loggedInGoogle: false,
    userGoogle: null,
    country: 'IN'
  },
  
  getters: {
    isAuthenticated: state => !!state.userGoogle,
    currentUser: state => state.userGoogle,
    country: state => state.country
  },
  
  mutations: {
    setLoggedInGoogle(state, status) {
      state.loggedInGoogle = status;
    },
    
    setUserGoogle(state, user) {
      state.userGoogle = user;
    },
    setCountry(state, country){
      state.country = country
    }
  },
  
  actions: {
    login({ commit }, userData) {
        console.log("vuex store", userData)
      commit('setLoggedInGoogle', true);
      commit('setUserGoogle', userData);
    },
    
    logout({ commit }) {
      commit('setLoggedInGoogle', false);
      commit('setUserGoogle', null);
    },
  },
});